export const EntryPointActions = {
  DELETE: 'DELETE_ENTRY_POINT',
  UPSERT: 'UPSERT_ENTRY_POINT',
  GET: 'GET_ENTRY_POINT',
  LIST_ENTRY_POINTS: 'LIST_ENTRY_POINTS',
  GET_AVAILABLE_HOURS: 'GET_AVAILABLE_HOURS',
  GET_QUEUES: 'GET_QUEUES',
  GET_FLOWS: 'GET_FLOWS',
  GET_PROMPTS: 'GET_PROMPTS',
  SET_CUSTOMER_QUEUE_FLOWS: 'SET_CUSTOMER_QUEUE_FLOWS',
  LOADING_ENTRY_POINTS: 'LOADING_ENTRY_POINTS',
  DELETING_ENTRY_POINT: 'DELETING_ENTRY_POINT',
  LIST_MENUS: 'LIST_MENUS',
  LOADING_MENUS: 'LOADING_MENUS',
  GET_NUMBERS: 'GET_NUMBERS',
  SET_AVAILABLE_NUMBERS: 'SET_AVAILABLE_NUMBERS',
  SET_AVAILABLE_CUSTOM_HOURS: 'SET_AVAILABLE_CUSTOM_HOURS',
  SET_MESSAGE: 'SET_MESSAGE',
  LOADING_QUEUE_TREATMENT: 'LOADING_QUEUE_TREATMENT',
  LIST_QUEUE_TREATMENT: 'LIST_QUEUE_TREATMENT',
};

export function entryPointReducer(state: any, action: any) {
  switch (action.type) {
    case EntryPointActions.DELETE: {
      // @todo Potentially remove entryPoint from list instead of listing again
      return {
        ...state,
        deletingEntryPoint: false,
      };
    }
    case EntryPointActions.DELETING_ENTRY_POINT: {
      // @todo Potentially remove entryPoint from list instead of listing again
      return {
        ...state,
        deletingEntryPoint: action.payload,
      };
    }
    case EntryPointActions.UPSERT: {
      // @todo Potentially append entryPoint in list instead of listing again
      return state;
    }
    case EntryPointActions.GET: {
      // @todo append latest entryPoint to list so the newest content is there in state
      return {
        ...state,
        workingEntryPoint: action.payload.workingEntryPoint,
      };
    }
    case EntryPointActions.LOADING_ENTRY_POINTS: {
      return {
        ...state,
        loadingEntryPoints: action.payload,
      };
    }
    case EntryPointActions.LIST_ENTRY_POINTS: {
      return {
        ...state,
        entryPointsLoaded: true,
        loadingEntryPoints: false,
        entryPointList: action.payload.entryPointList,
      };
    }
    case EntryPointActions.GET_AVAILABLE_HOURS: {
      return {
        ...state,
        availableHoursLoaded: true,
        loadingAvailableHours: false,
        availableHours: action.payload.availableHours,
      };
    }
    case EntryPointActions.GET_QUEUES:
      return {
        ...state,
        queuesLoaded: true,
        queues: action.payload.queues,
      };
    case EntryPointActions.GET_FLOWS:
      return {
        ...state,
        flowsLoaded: true,
        flows: action.payload.flows,
      };
    case EntryPointActions.GET_PROMPTS:
      return {
        ...state,
        promptsLoaded: true,
        prompts: action.payload.prompts,
      };
    case EntryPointActions.SET_CUSTOMER_QUEUE_FLOWS:
      return {
        ...state,
        customerQueueFlows: action.payload.customerQueueFlows,
      };
    case EntryPointActions.LIST_MENUS: {
      return {
        ...state,
        menusLoaded: true,
        menuList: action.payload.menuList,
      };
    }
    case EntryPointActions.GET_NUMBERS:
      return {
        ...state,
        numbersLoaded: true,
        numbers: action.payload.numbers,
      };
    case EntryPointActions.SET_AVAILABLE_NUMBERS:
      return {
        ...state,
        availableNumbers: action.payload,
      };
    case EntryPointActions.SET_AVAILABLE_CUSTOM_HOURS:
      return {
        ...state,
        availableCustomHours: action.payload,
      };
    case EntryPointActions.SET_MESSAGE:
      return {
        ...state,
        msg: action.payload.msg,
      };
    case EntryPointActions.LOADING_QUEUE_TREATMENT: {
      return {
        ...state,
        loadingQueueTreatments: action.payload,
      };
    }
    case EntryPointActions.LIST_QUEUE_TREATMENT: {
      return {
        ...state,
        queueTreatmentLoaded: true,
        loadingQueueTreatments: false,
        queueTreatmentList: action.payload.queueTreatmentList,
      };
    }
    default:
      return state;
  }
}
